module.exports = __webpack_public_path__ + "static/media/scotia-vida-ico-titular-rojo.305ef898.svg";